import { Component } from '@angular/core';

@Component({
    selector: 'loader',
    templateUrl: './loader.component.html',
    styleUrls: ['loader.component.scss'],
    standalone: true,
})
export class LoaderComponentComponent {
    constructor() {}
}
